import { CommonModule } from '@angular/common';
import { Component, Input, inject, signal } from '@angular/core';
import { TenantUsersApi } from '@buspro/web/apis';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { AvatarModule } from 'ngx-avatars';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'tenant-assigned-clerks-avatar-group',
  standalone: true,
  imports: [CommonModule, AvatarModule, NzTooltipDirective],
  template: `
    @if (parcelClerksQuery.isFetched()){
    <div class="avatar-group -space-x-4 rtl:space-x-reverse">
      <div *ngFor="let user of parcelClerksQuery.data()" class="avatar">
        <ngx-avatars
          nz-tooltip
          [nzTooltipTitle]="user.name"
          [name]="user.name"
          size="36"
        ></ngx-avatars>
      </div>

      <!--        <div class="avatar placeholder">-->
      <!--          <div class="bg-neutral text-neutral-content w-12">-->
      <!--            <span>+99</span>-->
      <!--          </div>-->
      <!--        </div>-->
    </div>
    }@else{
    <div class="avatar-group -space-x-3 rtl-space-x-reverse">
      <div class="skeleton h-8 w-8 shrink-0 rounded-full"></div>
      <div class="skeleton h-8 w-8 shrink-0 rounded-full"></div>
      <div class="skeleton h-8 w-8 shrink-0 rounded-full"></div>
    </div>
    }
  `,
  styles: ``,
})
export class AssignedClerksAvatarGroupComponent {
  userIds = signal<string[]>([]);

  @Input() set listOfClerkIds(value: string[]) {
    this.userIds.set(value);
  }

  private usersApi = inject(TenantUsersApi);

  parcelClerksQuery = injectQuery(() => ({
    queryKey: ['route-clerks', this.userIds()],
    queryFn: () =>
      lastValueFrom(
        this.usersApi.tenantUsersControllerGetSpecificList({
          body: {
            userIds: this.userIds(),
          },
        }),
      ),
  }));
}
